function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnGoogleLightNormalIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.99922,0,0,1.99922,5.00702,5.00702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google-Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn_google_light_normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.64,9.205C17.64,8.566 17.583,7.953 17.476,7.364L9,7.364L9,10.845L13.844,10.845C13.635,11.97 13.001,12.923 12.048,13.561L12.048,15.82L14.956,15.82C16.658,14.253 17.64,11.945 17.64,9.205Z",
    style: {
      fill: "rgb(66,133,244)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape1",
    serifId: "Shape",
    d: "M9,18C11.43,18 13.467,17.194 14.956,15.82L12.048,13.561C11.242,14.101 10.211,14.42 9,14.42C6.656,14.42 4.672,12.837 3.964,10.71L0.957,10.71L0.957,13.042C2.438,15.983 5.482,18 9,18Z",
    style: {
      fill: "rgb(52,168,83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape2",
    serifId: "Shape",
    d: "M3.964,10.71C3.784,10.17 3.682,9.593 3.682,9C3.682,8.407 3.784,7.83 3.964,7.29L3.964,4.958L0.957,4.958C0.348,6.173 0,7.548 0,9C0,10.452 0.348,11.827 0.957,13.042L3.964,10.71Z",
    style: {
      fill: "rgb(251,188,5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape3",
    serifId: "Shape",
    d: "M9,3.58C10.321,3.58 11.508,4.034 12.44,4.925L15.022,2.344C13.463,0.892 11.426,0 9,0C5.482,0 2.438,2.017 0.957,4.958L3.964,7.29C4.672,5.163 6.656,3.58 9,3.58Z",
    style: {
      fill: "rgb(234,67,53)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape4",
    serifId: "Shape",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    style: {
      fill: "none"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGoogleLightNormalIos);
export default __webpack_public_path__ + "static/media/btn_google_light_normal_ios.98fe27d32022b997480e6b248cbea173.svg";
export { ForwardRef as ReactComponent };